export const DEVANAGARI_FONTS = [
  "Noto Sans Devanagari", "Noto Serif Devanagari", "Mukta", "Hind", "Poppins", "Baloo 2",
  "Tiro Devanagari Hindi", "Tiro Devanagari Marathi", "Rozha One", "Kalam", "Teko", "Yatra One",
  "Khand", "Rajdhani", "Martel", "Martel Sans", "Karma", "Amita", "Sarala", "Laila", "Kurale",
  "Eczar", "Halant", "Palanquin", "Palanquin Dark", "Sarpanch", "Biryani", "Jaldi", "Kadwa",
  "Cambay", "Arya", "Sura", "Sahitya", "Inknut Antiqua", "Glegoo", "Pragati Narrow", "Modak",
  "Khula", "Asar", "Vesper Libre", "Dekko", "Gotu", "Kumar One", "Tillana", "Yantramanav",
  "Amiko", "Akshar", "Anek Devanagari", "Rhodium Libre", "Ranga", "Jaini", "Noto Sans",
];

export const LATIN_FONTS = [
  "Anton", "Bebas Neue", "Montserrat", "Oswald", "Bangers", "Luckiest Guy", "Archivo Black",
  "Lilita One", "Bungee", "Rubik", "Nunito", "Lato", "Open Sans", "Raleway", "Playfair Display",
  "Merriweather", "Lobster", "Pacifico", "Permanent Marker", "Righteous", "Fredoka", "Comfortaa",
  "Russo One", "Black Ops One", "Staatliches", "Alfa Slab One", "Bowlby One", "Passion One",
  "Titan One", "Chewy", "Bungee Inline", "Monoton", "Press Start 2P", "VT323", "Orbitron",
  "Audiowide", "Space Mono", "DM Sans", "Manrope", "Sora", "Outfit", "Lexend", "Kanit",
  "Barlow Condensed", "Fjalla One", "Abril Fatface", "Dancing Script", "Caveat", "Satisfy",
  "Shadows Into Light", "Kaushan Script", "Sigmar One", "Paytone One", "Changa One", "Ultra",
  "Rubik Mono One", "Bungee Shade", "Faster One", "Creepster", "Archivo Narrow", "Work Sans",
  "Exo 2", "Josefin Sans", "Quicksand", "Cinzel", "Libre Baskerville", "Roboto Slab",
  "Zilla Slab", "Arvo",
];

export const ALL_FONTS = [...DEVANAGARI_FONTS, ...LATIN_FONTS];

const loaded = new Map();

function addLink(href) {
  return new Promise((res) => {
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = href;
    l.onload = res;
    l.onerror = res;
    document.head.appendChild(l);
  });
}

export function loadFont(name) {
  if (!name) return Promise.resolve();
  if (loaded.has(name)) return loaded.get(name);
  const fam = encodeURIComponent(name).replace(/%20/g, "+");
  const p = Promise.all([
    addLink(`https://fonts.googleapis.com/css2?family=${fam}&display=swap`),
    addLink(`https://fonts.googleapis.com/css2?family=${fam}:wght@700;800;900&display=swap`),
  ])
    .then(() => Promise.all([
      document.fonts.load(`400 32px "${name}"`, "Aaनम"),
      document.fonts.load(`800 32px "${name}"`, "Aaनम"),
    ]))
    .catch(() => null);
  loaded.set(name, p);
  return p;
}
